exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".component-edit-or-add-signature .edit-button{position:absolute!important;right:8px;top:8px;z-index:1}.component-edit-or-add-signature .preview-signature-border{border:1px solid #ddd;border-radius:2px}", ""]);

// exports
